import React from 'react';

const EditIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" },
    className
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14 14.6665H2C1.72667 14.6665 1.5 14.4398 1.5 14.1665C1.5 13.8932 1.72667 13.6665 2 13.6665H14C14.2733 13.6665 14.5 13.8932 14.5 14.1665C14.5 14.4398 14.2733 14.6665 14 14.6665Z",
      fill: "white",
      fillOpacity: "0.6"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.6804 2.31994C11.387 1.02661 10.1204 0.993275 8.79371 2.31994L7.98704 3.12661C7.92037 3.19328 7.89371 3.29994 7.92038 3.39328C8.42704 5.15994 9.84038 6.57328 11.607 7.07994C11.6337 7.08661 11.6604 7.09328 11.687 7.09328C11.7604 7.09328 11.827 7.06661 11.8804 7.01328L12.6804 6.20661C13.3404 5.55328 13.6604 4.91994 13.6604 4.27994C13.667 3.61994 13.347 2.97994 12.6804 2.31994Z",
      fill: "white",
      fillOpacity: "0.6"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.4056 7.68654C10.2122 7.5932 10.0256 7.49987 9.84558 7.3932C9.69891 7.30654 9.55891 7.2132 9.41891 7.1132C9.30558 7.03987 9.17224 6.9332 9.04558 6.82654C9.03224 6.81987 8.98558 6.77987 8.93224 6.72654C8.71224 6.53987 8.46558 6.29987 8.24558 6.0332C8.22558 6.01987 8.19224 5.9732 8.14558 5.9132C8.07891 5.8332 7.96558 5.69987 7.86558 5.54654C7.78558 5.44654 7.69224 5.29987 7.60558 5.1532C7.49891 4.9732 7.40558 4.7932 7.31224 4.60654C7.18987 4.34431 6.8457 4.26641 6.64108 4.47103L2.89224 8.21987C2.80558 8.30654 2.72558 8.4732 2.70558 8.58654L2.34558 11.1399C2.27891 11.5932 2.40558 12.0199 2.68558 12.3065C2.92558 12.5399 3.25891 12.6665 3.61891 12.6665C3.69891 12.6665 3.77891 12.6599 3.85891 12.6465L6.41891 12.2865C6.53891 12.2665 6.70558 12.1865 6.78558 12.0999L10.5406 8.34484C10.7411 8.14432 10.6658 7.79929 10.4056 7.68654Z",
      fill: "white",
      fillOpacity: "0.6"
    }
  )
);
EditIcon.displayName = "Icons.EditIcon";

export { EditIcon };
//# sourceMappingURL=Edit.js.map
